import { all, takeEvery, fork, put, select } from 'redux-saga/effects';
import { staticViewsActionTypes, staticViewsActionsInterfaces, staticViewsSelectors, staticViewsActions } from '.';
import StringBuilder from '../../helpers/StringBuilder';
import { mySubjectsActionTypes } from './mySubjects';
import { studentsActionTypes } from './students';

/*
  Sagi z Transfer w nazwie są sagami przejściówkowymi - ich zadaniem jest uruchomić akcje dedykowane dla konkretnych zakładek.
  Sposób dispatchowania tych akcji nie jest type safety, dlatego przy implementacji kolejnych sag tego typu należy zwracać szczególną uwagę
  na nazewnictwo typu akcji oraz przekazanie pełnego payloadu.
  Sagi przejściówkowe zastosowano, aby ograniczyć ilości przekazywanych akcji bezpośrednio do komponentów widoków
  za pośrednictwem mapDispatchToProps, tym bardziej, że wiele z nich się powtarza.
  Wszystkie akcje przekazywane są za pośrednictwem HOCa withViewDataSetHandler.
*/
export function* initTransferWatcher(): Generator {
  yield takeEvery(staticViewsActionTypes.INIT, initTransfer);
}
export function* initTransfer(action: staticViewsActionsInterfaces.Init): Generator {
  yield put({
    type: `${StringBuilder.toUnderscoreUpperCase(action.payload.view)}/INIT`,
    payload: action.payload,
  });
}

export function* getRecordDetailsTransferWatcher(): Generator {
  yield takeEvery(staticViewsActionTypes.RECORD_GET_DETAILS_START, getRecordDetailsTransfer);
}
export function* getRecordDetailsTransfer(action: staticViewsActionsInterfaces.GetRecordDetailsStart): Generator {
  yield put({
    type: `${StringBuilder.toUnderscoreUpperCase(action.payload.view)}/RECORD_GET_DETAILS_START`,
    payload: action.payload,
  });
}


export function* saveColumnsUserSetupTransferWatcher(): Generator {
  yield takeEvery(staticViewsActionTypes.COLUMNS_SAVE_USER_SETUP_START, saveColumnsUserSetupTransfer);
}
export function* saveColumnsUserSetupTransfer(action: staticViewsActionsInterfaces.SaveColumnsUserSetupStart): Generator {
  yield put({
    type: `${StringBuilder.toUnderscoreUpperCase(action.payload.view)}/COLUMNS_SAVE_USER_SETUP_START`,
    payload: action.payload,
  });
}

export function* refreshDataTransferWatcher(): Generator {
  yield takeEvery(staticViewsActionTypes.REFRESH_DATA_START, refreshDataTransfer);
}
export function* refreshDataTransfer(action: staticViewsActionsInterfaces.RefreshDataStart): Generator {
  yield put({
    type: `${StringBuilder.toUnderscoreUpperCase(action.payload.view)}/REFRESH_DATA_START`,
    payload: action.payload,
  });
}

export function* refreshDataAfterSearchTransferWatcher(): Generator {
  yield takeEvery(staticViewsActionTypes.GET_DATA_START, refreshDataAfterSearchTransfer);
}
export function* refreshDataAfterSearchTransfer(action: staticViewsActionsInterfaces.GetDataStart): Generator {
  yield put({
    type: `${StringBuilder.toUnderscoreUpperCase(action.payload.view)}/GET_DATA_START`,
    payload: action.payload,
  });
}

export function* getDataNextPageTransferWatcher(): Generator {
  yield takeEvery(staticViewsActionTypes.GET_DATA_NEXT_PAGE_START, getDataNextPageTransfer);
}
export function* getDataNextPageTransfer(action: staticViewsActionsInterfaces.GetDataNextPageStart): Generator {
  yield put({
    type: `${StringBuilder.toUnderscoreUpperCase(action.payload.view)}/GET_DATA_NEXT_PAGE_START`,
    payload: action.payload,
  });
}

export function* syncDataWithCacheTransferWatcher(): Generator {
  yield takeEvery(staticViewsActionTypes.SYNC_DATA_WITH_CACHE_START, syncDataWithCacheTransfer);
}
export function* syncDataWithCacheTransfer(action: staticViewsActionsInterfaces.SyncDataWithCacheStart): Generator {
  yield put({
    type: `${StringBuilder.toUnderscoreUpperCase(action.payload.view)}/SYNC_DATA_WITH_CACHE_START`,
    payload: action.payload,
  });
}

export function* refreshFilterValuesTransferWatcher(): Generator {
  yield takeEvery([
    staticViewsActionTypes.FILTERS_SELECT_VALUES,
    staticViewsActionTypes.FILTERS_OPEN_CATEGORY,
    staticViewsActionTypes.FILTERS_CLOSE_CATEGORY,
  ], refreshFilterValuesTransfer);
}
/**
 * inicjalizacja odświeżenia listy wartości filtrów
 *
 * @export
 * @return {*}  {Generator}
 */
export function* refreshFilterValuesTransfer(
  action: staticViewsActionsInterfaces.OpenFilterCategory | staticViewsActionsInterfaces.CloseFilterCategory | staticViewsActionsInterfaces.SelectFilterValues
): Generator {
  const { initTable } = (yield select(state => staticViewsSelectors.getStaticViewState(state, action.payload.view))) as ViewDataSet;
  if (!initTable) {
    yield put({
      type: `${StringBuilder.toUnderscoreUpperCase(action.payload.view)}/FILTERS_REFRESH_VALUES_START`,
      payload: { view: action.payload.view },
    });
  }
}

export function* clearSelectedWatcher(): Generator {
  yield takeEvery([
    staticViewsActionTypes.SET_ORDER,
    staticViewsActionTypes.SET_SEARCH,
    mySubjectsActionTypes.FILTERS_REFRESH_VALUES_START,
    studentsActionTypes.FILTERS_REFRESH_VALUES_START,
  ], clearSelected);
}
/**
 * wyczyszcznie tablicy zaznaczonych elementów tabeli
 *
 * @export
 * @return {*}  {Generator}
 */
export function* clearSelected(action: staticViewsActionsInterfaces.SetSearch | staticViewsActionsInterfaces.SetOrder): Generator {
  const { selected } = (yield select(state => staticViewsSelectors.getStaticViewState(state, action.payload.view))) as ViewDataSet;
  yield put(staticViewsActions.setPage(action.payload.view, 1));
  if (selected.length) {
    yield put(staticViewsActions.setSelected(action.payload.view, []));
  }
}

export default function* rootSaga(): Generator {
  yield all([
    fork(initTransferWatcher),
    fork(getRecordDetailsTransferWatcher),
    fork(saveColumnsUserSetupTransferWatcher),
    fork(refreshDataTransferWatcher),
    fork(refreshDataAfterSearchTransferWatcher),
    fork(getDataNextPageTransferWatcher),
    fork(syncDataWithCacheTransferWatcher),
    fork(refreshFilterValuesTransferWatcher),
    fork(clearSelectedWatcher),
  ]);
}